import { Box, Text } from '@stitch-fix/mode-react';
import { FullBodyUpload } from './FullBodyUpload';
import { useGetClientFullBodyQuery } from './graphql/getClientFullBody';
import { SupportedBusinessLine } from './Onboarding';
import PhotoTips from './PhotoTips';

const ReOnboardingFullBody = ({
  businessLine,
}: {
  businessLine: SupportedBusinessLine;
}) => {
  const { data: clientData, refetch: refetchFullBody } =
    useGetClientFullBodyQuery();

  const fullBodyImage = clientData?.client?.photoFullBody?.image;
  const existingFullBodyUrl = fullBodyImage
    ? `${fullBodyImage.baseUrl}${fullBodyImage.mediaPath}`
    : null;

  return (
    <Box maxWidth={54} mx="auto">
      <Text setting="eyebrow-small" color="gray-55" mb={0.5}>
        OPTIONAL
      </Text>
      <Text setting="title-small" mb={1.5} color="gray-16">
        <strong>Add a full-body image</strong>
      </Text>
      <Box mb={3}>
        <FullBodyUpload
          id={clientData?.client?.photoFullBody?.id}
          existingImageUrl={existingFullBodyUrl}
          onChange={() => refetchFullBody()}
        />
      </Box>
      <PhotoTips
        businessLine={businessLine}
        mode="headshot"
        showProfileSettingsCopy={false}
      />
    </Box>
  );
};

export default ReOnboardingFullBody;
